/* eslint-disable */
<template>
    <div class="rounded-lg p-3 lg:p-5 bg-bg border border-bg-dark border-solid mt-5">
        <div class="flex justify-between">
            <Checkbox v-model:checked="checked" :disabled="isOngoing && hasStarted">
                <h3 class="text-xl text-primary-dark">App promotion incentives</h3>
            </Checkbox>

            <SaveBtn :disabled="!isShowCheckedSaved" :loading="isFetching" @click="handleSave" class="mt-0" />
        </div>
        <div v-if="checked">
            <div class="mt-6">
                <div class="text-center flex flex-wrap items-center justify-center gap-2">
                    <span class="font-bold">Each employee receives a one-time monetary incentives of </span>
                    <InputNumber class="w-20" :defaultValue="rewardData.promotion_incentives"
                    :disabled="isOngoing && hasStarted" v-model:value="value" :min="0" prefix="$" :step="0.5" />

                    <span class="font-bold">for logging</span>
                    <InputNumber class="w-20" :defaultValue="rewardData.promotion_trips"
                        :disabled="isOngoing && hasStarted" v-model:value="trips" :min="0" :step="2" />
                    <!-- @change="setVal" -->
                    <span class="font-bold">trips</span>
                </div>
            </div>
            <div class="flex items-center mt-3 gap-6 flex-wrap flex-col lg:flex-row justify-center">
                <div class="text-center flex flex-col flex-wrap justify-center items-center">
                    <span class="font-bold">Incentive Start Date</span>
                    <div class="w-40">
                        <CustumCalender name="incentive_start_date" :defaultData="promotion_incentives_start_date"
                            defaultFormate="MMM, D, YYYY" placeholder="Select Date" :rules="{
                                required: false,
                            }" @setInput="setInput" />
                    </div>
                </div>

                <!-- v-if="!ongoingChecked" -->
                <div class="text-center flex flex-col flex-wrap justify-center items-center">
                    <span class="font-bold">Incentive End Date</span>
                    <div class="w-40">
                        <CustumCalender name="incentive_end_date"
                            :defaultData="promotion_incentives_end_date" defaultFormate="MMM, D, YYYY"
                            placeholder="Select Date" :rules="{
                                required: false,
                            }" @setInput="setInput" />
                    </div>
                </div>
            </div>
            <div class="w-full flex justify-center md:justify-end">
                <SaveBtn :disabled="!isValueChanged" :loading="isFetching" @click="handleSave" />
            </div>

        </div>

    </div>
</template>

<script>
/* eslint-disable */
import { Checkbox, InputNumber } from 'ant-design-vue';
import { mapMutations } from 'vuex';
import debounce from 'lodash.debounce';
import SaveBtn from '../shared/SaveBtn.vue';
import { REWARD } from '../../../../store/types';
import CustumCalender from '@/components/shared/form/CustumCalender.vue';
import dayjs from 'dayjs';

export default {
    components: {
        Checkbox,
        InputNumber,
        SaveBtn,
        CustumCalender
    },
    props: {
        isOngoing: {
            type: Boolean,
            default: false,
        },
        hasStarted: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            checked: false,
            value: 0,
            trips: 0,
            promotion_incentives_start_date: dayjs(),
            promotion_incentives_end_date: dayjs().add(1, 'week'),
        };
    },

    created() {
        if (this.rewardData) {
            this.value = this.rewardData.promotion_incentives;
            this.checked = this.rewardData.app_promotion_enabled;
            this.promotion_incentives_start_date = this.rewardData?.promotion_incentives_start_date ? dayjs(this.rewardData?.promotion_incentives_start_date?.split('T')[0], 'YYYY-MM-DD') : dayjs();
            this.promotion_incentives_end_date = this.rewardData?.promotion_incentives_end_date ? dayjs(this.rewardData?.promotion_incentives_end_date?.split('T')[0], 'YYYY-MM-DD') : dayjs().add(1, 'week');
            this.trips = this.rewardData.promotion_trips ?? 10;
        }
    },
    computed: {
        rewardData() {
            return this.$store.getters.rewardSettingsData;
        },
        defaultRewardData() {
            return this.$store.getters.rewardDefaultsData;
        },
        isFetching() {
            return this.$store.state.reward.rewardSettingsQuery?.isFetching;
        },

        isValueChanged() {
            if (this.checked && this.checked !== this.rewardData.app_promotion_enabled) return true;
            // eslint-disable-next-line eqeqeq
            return this.rewardData.promotion_incentives != this.value || this.rewardData.promotion_trips != this.trips;
        },
        isShowCheckedSaved() {
            return !this.checked && this.checked !== this.rewardData.app_promotion_enabled;
        },
    },
    methods: {
        ...mapMutations([REWARD.SET_SIGNUP_INCENTIVES_DATA, REWARD.SET_SELECTED_SYSTEM]),
        handleSave() {
            this.setVal(this.value);
        },
        setVal(val) {
            // this.SET_SIGNUP_INCENTIVES_DATA(val);
            this.debounceSetVal(+val, this);
        },
        debounceSetVal: debounce((val, app) => {
            app.$store.dispatch(REWARD.ACTION_UPDATE_REWARD_SYS, {
                promotion_incentives: val,
                promotion_trips: app.trips,
                app_promotion_enabled: app.checked,
                promotion_incentives_start_date: app.promotion_incentives_start_date,
                promotion_incentives_end_date: app.promotion_incentives_end_date,
            });
        }, 600),
        setInput(val) {
            if (!this.rewardData) return;
            if (val && val.incentive_start_date && val.incentive_start_date.value) {
                // const start_date = dayjs(val.start_date.value, 'MMM, D, YYYY').format('YYYY-MM-DD');
                this.promotion_incentives_start_date = dayjs(val.incentive_start_date.value, 'MMM, D, YYYY');
                // if (this.rewardData.start_date === start_date) return;
                // this.$store.dispatch(REWARD.ACTION_UPDATE_REWARD_SYS, {
                //   start_date,
                // });
            }

            if (val && val.incentive_end_date && val.incentive_end_date.value) {
                // const end_date = dayjs(val.end_date.value, 'MMM, D, YYYY').format('YYYY-MM-DD');
                this.promotion_incentives_end_date = dayjs(val.incentive_end_date.value, 'MMM, D, YYYY');
                // if (this.rewardData.end_date === end_date) return;
                // this.$store.dispatch(REWARD.ACTION_UPDATE_REWARD_SYS, {
                //   end_date,
                // });
            }
        },
        changedStartDate(val) {
            this.setInput(val)
        }
    },
};
</script>